import { useParams } from 'react-router-dom';
import NomineeInvestmentAttributions from '@pages/NomineeInvestmentAttributions/NomineeInvestmentAttributions';
import { Header, Loader } from '@components';
import { useUserQuery } from '@features/api/userSlice';
import { useIntl } from 'react-intl';
import {
  Container,
  StyledHeaderContainer,
} from './NomineeInvestmentDetails.styles';

export default function NomineeInvestmentDetails() {
  const intl = useIntl();
  const { transactionId } = useParams();
  const { data: user, isLoading: isLoadingUser } = useUserQuery();

  if (isLoadingUser) return <Loader isLoading />;
  return (
    <Container>
      <StyledHeaderContainer>
        <Header
          user={user}
          title={{
            name: intl.formatMessage({ id: 'menu.crm' }),
            to: '/crm',
          }}
          subtitles={[
            {
              name: intl.formatMessage({ id: 'crm.customerInvestmentsTitle' }),
              to: '/crm/investments',
            },
            {
              name: transactionId,
              to: `/crm/investments/${transactionId}`,
            },
          ]}
        />
      </StyledHeaderContainer>
      <NomineeInvestmentAttributions transactionId={Number(transactionId)} />
    </Container>
  );
}
